$(() => {
    if (document.getElementById('agent-client-contract-setting') != null) {

        $('.js-contract-setting').on('click', function(e) {
            $('#agent-client-contract-setting-modal').modal('show');
        });
        $('.agent-client-contract-setting-exec').on('click', function() {
            $('#form').submit();
        });

        $('.js-client-invite').on('click', function(e) {
            e.preventDefault();
            $('#client-invite-modal').modal('show');
        });

        $('.client-invite-exec').prop('disabled', true);
        $('#email').on('keyup', function() {
            if ($(this).val() == '') {
                $('.client-invite-exec').prop('disabled', true);
            } else {
                $('.client-invite-exec').prop('disabled', false);
            }
        });

        $('.client-invite-exec').on('click', function() {
            $('#client_invite').submit();
            $(this).prop('disabled', true);
        });
    }

});